import { render } from "./bottomUnderwearConfig.vue?vue&type=template&id=e782c28c&ts=true"
import script from "./bottomUnderwearConfig.vue?vue&type=script&lang=ts"
export * from "./bottomUnderwearConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__